export enum MerchantBankPurpose {
  'None' = 0,
  'Deposit',
  'Withdrawal',
  'Others',
  'Backup',
  'Deposit and Withdrawal'
}
